<template>
  <div class="d-flex alig-center w-100">
      <slot name="filtro">
        <!-- <i @click="showBusqueda()" :class="['unishop-search-icon icon-search4 pointer', $store.getters.isTicketsOpen || $store.getters.isFiltroOpen || $store.getters.isFiltroTicketsOpen ? 'deshab' : '']"></i> -->
          <div class="no-flex">
          <v-btn flat icon class="my-0 primary-color" @click="showFiltro()" v-if="iconoFiltro"> <v-icon>commit</v-icon></v-btn><!---->
          <v-badge
              color="orange"
              dark
              small
              mr-2
              v-if="filtroOn && !iconoCloseFiltro"
              >
              <template v-slot:badge>
                <v-icon class="white--text">priority_high</v-icon>
              </template>
            </v-badge>
          <i class="unishop-filter-on icon-filter3" v-if="filtroOn"></i>
          <v-btn flat icon class="my-0 primary-color" @click="closeFiltro()" v-if="iconoCloseFiltro"><v-icon>close</v-icon></v-btn>
        </div>
        <div  class="no-flex" v-if="!$store.getters.isTicketsOpen"><!--v-if="!$store.getters.isTicketsOpen && !localizadorOpen"
          <img @click="modalScan = true" src='@/assets/images/barcodescan.png'>-->
          <v-btn flat icon class="my-0 primary-color" @click="dialog = true" > <v-icon>flip</v-icon></v-btn><!--@click="modalScan = true"-->
          <v-icon class="" v-if="scanOn" @click="reset()">close</v-icon>
        </div>
        <div class="pl-2 d-flex no-flex align-center" v-if="!$store.getters.isTicketsOpen && localizadorOpen " >
            <v-text-field
              v-model="localizador"
              label="Localizador"
              class="pt-0"
              single-line
              @keyup.enter="searchByLocalizador()"
            >
            </v-text-field>
          <v-icon class="my-0 primary-color" v-if="!$store.getters.isTicketsOpen && (busquedaOn || filtroOn || scanOn)" @click="reset();">
            close
          </v-icon>
          <v-badge
              color="orange"
              dark
              small
              mr-2
              v-if="busquedaOn"
              >
              <template v-slot:badge>
                <v-icon class="white--text">priority_high</v-icon>
              </template>
            </v-badge>
            <!-- <div class="uf-reset" title="Reset" @click="reset();localizador=''"></div> -->
            <div class="uf-reset" title="Reset" @click="reset();localizadorOpen = true"></div>
            <i class="unishop-filter-on buscar-on icon-filter3" v-if="busquedaOn"></i>
           <div v-if="!$store.getters.isTicketsOpen" class=" pointer">
              <v-btn flat icon @click="!localizadorOpen ? localizadorOpen = true : searchByLocalizador()" 
                :class="['pointer my-0', $store.getters.isTicketsOpen || $store.getters.isFiltroOpen || $store.getters.isFiltroTicketsOpen ? 'deshab' : '']">
                <v-icon class="primary-color">search</v-icon>
              </v-btn>
            </div>
        </div>
      </slot>
      <div class="ml-auto no-flex vertical-center mr-1 d-flex align-center">
        <slot name="carrito">
          <a class="unishop-cart ml-auto mr-3 d-flex align-center" @click.stop="showCarritoModal()">
            <v-icon class="primary-color">shopping_cart</v-icon>
            <!--<img src='@/assets/images/aparcar_ticket_blue.png'>-->
            <v-avatar size="28px" class="orange white--text">{{ numProductsAdded }}</v-avatar>
          </a>
        </slot>
        <slot name="tickets-aparcados">
          <a @click="showTicketsAparcados()" v-if="!$store.getters.isTicketsOpen" class="unishop-tickets mr-3 pt-1">
            <!--<img src='@/assets/images/lista_tickets_aparcados_2.png'>-->
            <img size="28px" src='@/assets/images/ticket.svg'>
          </a>
          <a @click="closeTicketsAparcados()" v-if="$store.getters.isTicketsOpen" class="unishop-tickets mr-3 pt-1">
            <!--<img src='@/assets/images/lista_tickets_aparcados_blue.png'>-->
            <img size="28px" src='@/assets/images/ticket-back.svg'>
          </a>
        </slot> 
      </div>
     <v-dialog
      v-model="dialog"
      max-width="400"
      class="no-flex"
    > 
      <div class="scan-dialog">
        <v-toolbar flat class="d-flex justify-space-between ">
            <v-toolbar-title class="primary-color"><v-icon class="mr-2 primary-color">flip</v-icon>Escanear localizador</v-toolbar-title>
            <v-btn 
              icon
              flat
              class="primary-color"
              @click="dialog = false">
            <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' >-->
            <!--{{ $t('lang.comun.salir') }}-->
            <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <code-scanner v-if="dialog" @search-by-ean-code="searchByEanCode" />
        <!--v-on:cerrar="modalScan=false" -->
      </div>
    </v-dialog>
	</div>
</template>

<script>
import CodeScanner from "../../../../components/CodeScanner.vue";

  export default {
    components: { CodeScanner, },
    name: 'Menu',

    data () {
      return {
        dialog: false,
        localizador: '',
        localizadorOpen: true,
        modalScan: false,
      }
    },
    computed: {
      numProductsAdded () {
        return this.$store.getters.getProductsCart.length;
			},
      filtroOn () {
        return (((this.$store.state.userInfo.hasSearched > 0 && !this.$store.getters.isTicketsOpen) || (this.$store.state.userInfo.hasTicketSearched > 0 && this.$store.getters.isTicketsOpen)) && (this.$store.state.userInfo.productLocalizadorSearched === '' && this.$store.state.userInfo.productEanSearched === ''))
      },
      iconoFiltro() {
        return (!this.$store.getters.isFiltroOpen && !this.$store.getters.isFiltroTicketsOpen && !this.$store.getters.isBusquedaOpen)
      },
      iconoCloseFiltro() {
        return this.$store.getters.isFiltroOpen || this.$store.getters.isFiltroTicketsOpen
      },
      busquedaOn () {
        return (this.$store.state.userInfo.hasSearched > 0 && (this.$store.state.userInfo.productLocalizadorSearched !== ''))
      },
      scanOn () {
        return (this.$store.state.userInfo.productEanSearched !== '')
      }
    },
    mounted() {
      this.localizador = this.$store.state.userInfo.productLocalizadorSearched
    },
    methods: {
      showFiltro () {
        window.scrollTo(0,0);
        if (!this.$store.getters.isTicketsOpen) {
          this.$store.commit('showFiltro', true);
        } else {
          this.$store.commit('showFiltroTickets', true); 
        }
      },
      showBusqueda () {
        if (!this.$store.getters.isBusquedaOpen) {
          if (!this.$store.getters.isTicketsOpen && !this.$store.getters.isFiltroOpen && !this.$store.getters.isFiltroTicketsOpen) {
            window.scrollTo(0,0);
            this.$store.commit('showBusqueda', true);
          }
        } else {
          this.$store.commit('showBusqueda', false);
        }
      },
      closeFiltro () {
        if (!this.$store.getters.isTicketsOpen) {
          this.$store.commit('showFiltro', false);
        } else {
          this.$store.commit('showFiltroTickets', false); 
        }
      },
      showTicketsAparcados () {
        this.$store.commit('showTickets', true);
        this.$store.commit('showFiltro', false);
        this.$store.commit('showFiltroTickets', false);
        this.$store.commit('showBusqueda', false);
      },
      closeTicketsAparcados () {
        this.$store.commit('showTickets', false);
        this.$store.commit('showFiltro', false);
        this.$store.commit('showFiltroTickets', false);
      },
      showCarritoModal () {
        if (this.$store.getters.isCarritoModalOpen) {
          this.$store.commit('showCarritoModal', false);
        } else {
          this.$store.commit('showCarritoModal', true);
        }
      },
      searchByLocalizador () {
        if (this.localizador.length > 0) {
          this.$store.commit('setHasUserSearched', this.$store.state.userInfo.hasSearched + 1);
          this.$store.commit('setProductLocalizadorSearched', this.localizador);
          this.$store.commit('cambioPag', 1)
        }
      },
      searchByEanCode (ean) {
        if (ean.length > 0) {
          this.modalScan = false
          this.$store.commit('setHasUserSearched', this.$store.state.userInfo.hasSearched + 1);
          this.$store.commit('setProductEanSearched', ean.replace(/[^A-Z0-9]/ig, ""));
          this.$store.commit('cambioPag', 1)
        } else {
          this.$root.$emit('mostrarAlerta', this.$t('lang.error.scan'), 'error')
        }
      },
      reset () {
        this.localizador=''
        this.$store.commit('cambioPag', 1)
        this.$store.commit('setHasUserSearched', 0);
        this.$store.commit('setProductLocalizadorSearched', '');
        this.$store.commit('setProductEanSearched', '');
      }
    }
  };
</script>
